import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Of penguins and OSes",
  "description": "",
  "published": "2006-05-01T00:00:00.000Z",
  "redirect_from": ["/blog/of-penguins-and-oses/swizec/423"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago, on Thursday to be precice, a great journey has begun, a journey into the lands of penguins and operating systems. After a short and bitter format of the main hard-drive came a long and bloody battle for the installation of a fresh `}<a parentName="p" {...{
        "href": "http://gentoo.org"
      }}>{`Gentoo linux`}</a>{`. The battle had lasted for roughly three days and still there are some things to be done. The scanner, for instance, is still being a bourden that doesn't quite function.`}</p>
    <p>{`Work has also started on the first issue of Cthulhu and what's come out of the blank paper so far isn't at all too shabby. I managed to pencil the first panel, which was an endeavour that took roughly an hour. Come to think of it, the first issue has 14 of these panels and it makes me cry. When you add another two hours for colour of a single panel you can see that the making of the first issue is to take roughly 42 hours, which must be the reason why this comic is refreshed only monthly. From another perspective, an average work week contains 42 hours, so if this comic was to be updated weekly...`}</p>
    <p>{`A new `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{`static page`}</a>{` has also been made, the very first actually `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{`its`}</a><a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{` reason are purely and only `}</a><a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=pages/submode=Links"
      }}>{`links.`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      